export default __webpack_public_path__ + "images/e544c00016b936505be06c3a78951ca5-purple-financing.svg";